import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { isEmpty } from 'lodash'
import ReactHintFactory from 'react-hint'

import {
  EditProfile,
  Fiscalization,
  LiqpayAccountForm,
  Notifications,
  Settings,
} from '../../components/Settings'
import { subscriptionUnsubscribeRequest } from '../../store/subscriptions/actions'
import { SETTINGS_SECTIONS } from '../../constants'
import { profileGetRequest, profileUpdateRequest } from '../../store/profiles/actions'
import { adminDeleteRequest } from '../../store/admin/actions'
import { Modal } from '../../components/UIkit'
import { liqpayAccountCreateRequest, liqpayAccountGetRequest } from '../../store/liqpayAccounts/actions'
import LiqpayAccountInfo from '../../components/Settings/Sections/LiqpayAccountInfo'
import './styles.scss'
import { checkboxIntegrationGetRequest, checkboxIntegrationUpdateRequest } from '../../store/fiscalization/actions'

const SettingsContainer = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const location = useLocation()
  const history = useNavigate()

  const [activeSection, setActiveSection] = useState(!isMobile && (location.state?.tab || SETTINGS_SECTIONS.profile))
  const [isOpen, setIsOpen] = useState(false)

  const { items: subscriptions } = useSelector((state) => state.subscriptions)
  const {
    profile: profile,
    fetching: profileFetching,
    updating: profileUpdating
  } = useSelector((state) => state.profiles)
  const { network } = useSelector((state) => state.networks)
  const { currentSession } = useSelector((state) => state.authentication)
  const { liqpayAccount } = useSelector((state) => state.liqpayAccounts)
  const { items: fiscalizationItems } = useSelector((state) => state.fiscalization)

  const getProfile = () => dispatch(profileGetRequest())
  const updateProfile = (data) => dispatch(profileUpdateRequest(data))

  const deleteProfile = () => dispatch(adminDeleteRequest({ history }))

  const getLiqpayAccount = () => dispatch(liqpayAccountGetRequest())
  const createLiqpayAccount = (data) => dispatch(liqpayAccountCreateRequest(data))

  const getFiscalizationInfo = () => dispatch(checkboxIntegrationGetRequest())
  const updateFiscalizationInfo = (data) => dispatch(checkboxIntegrationUpdateRequest(data))

  const isSubscribing = (setting) => subscriptions.find((sub) => setting.key === sub.key)?.subscribing

  const handleUpdateSwitch = ({ target }) => {
    const subscription = subscriptions.find((sub) => target.id === sub.key)
    const userId = subscription.targetId
    const id = subscription.id
    const subscribing = !subscription.subscribing

    dispatch(subscriptionUnsubscribeRequest({ userId, id, subscribing }))
  }

  useEffect(() => {
    getProfile()
    getLiqpayAccount()
    getFiscalizationInfo()
  }, [])

  const handleClose = () => {
    setIsOpen(false)
  }

  const parsedBaristas = () => {
    let newArray = []
    fiscalizationItems.map((v) => {
      v.baristas.map((b) => newArray.push(b))
    })

    return newArray
  }

  const renderSection = () => {
    switch (activeSection) {
      case SETTINGS_SECTIONS.profile:
        return (
          !profileFetching && <EditProfile
            deleteAdminProfile={deleteProfile}
            profile={profile}
            updating={profileUpdating}
            updateProfile={updateProfile}
          />
        )
      case SETTINGS_SECTIONS.liqpay:
        return (
          isEmpty(liqpayAccount)
            ? <LiqpayAccountForm
              network={network}
              currentSession={currentSession}
              createLiqpayAccount={createLiqpayAccount}
            />
            : <LiqpayAccountInfo
              liqpayAccount={liqpayAccount}
            />
        )
      case SETTINGS_SECTIONS.notifcations:
        return <Notifications isSubscribing={isSubscribing} handleUpdateSwitch={handleUpdateSwitch} />
      case SETTINGS_SECTIONS.fiscalization:
        return (
          <Fiscalization
            networkCheckboxIntegrated={network.checkboxIntegrated}
            vendors={fiscalizationItems}
            baristas={parsedBaristas()}
            handleUpdate={updateFiscalizationInfo}
          />
        )
    }
  }

  const renderMobileSection = () => {
    switch (activeSection) {
      case SETTINGS_SECTIONS.profile:
        return (
          !profileFetching && <Modal mobileModal title={t('settings:editProfile:title')} show={isOpen} handleClose={handleClose} >
            <EditProfile
              deleteAdminProfile={deleteProfile}
              profile={profile}
              updating={profileUpdating}
              updateProfile={updateProfile}
            />
          </Modal>
        )
      case SETTINGS_SECTIONS.liqpay:
        return (
          <Modal title={t('settings:liqpay:title')} show={isOpen} handleClose={handleClose} mobileModal>
            {isEmpty(liqpayAccount)
              ? <LiqpayAccountForm
                network={network}
                currentSession={currentSession}
                createLiqpayAccount={createLiqpayAccount}
              />
              : <LiqpayAccountInfo
                liqpayAccount={liqpayAccount}
              />}
          </Modal>
        )
      case SETTINGS_SECTIONS.notifcations:
        return (
          <Modal title={t('notifications:title')} show={isOpen} handleClose={handleClose} mobileModal >
            <Notifications isSubscribing={isSubscribing} handleUpdateSwitch={handleUpdateSwitch} />
          </Modal>
        )
      case SETTINGS_SECTIONS.fiscalization:
        return (
          <Modal title={t('settings:fiscalization:title')} show={isOpen} handleClose={handleClose} mobileModal>
            <Fiscalization
              networkCheckboxIntegrated={network.checkboxIntegrated}
              vendors={fiscalizationItems}
              baristas={parsedBaristas()}
              handleUpdate={updateFiscalizationInfo}
            />
          </Modal>
        )
    }
  }

  const ReactHint = ReactHintFactory(React)

  return (
    <>
      <ReactHint
        className='settings__react-hint'
        events
      />
      <Settings
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        renderSection={renderSection}
        renderMobileSection={renderMobileSection}
        setOpen={setIsOpen}
      />
    </>
  )
}

export default SettingsContainer
